"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
const tx_1 = require("cosmjs-types/cosmos/distribution/v1beta1/tx");
const constants_1 = require("../../constants");
const epochingtx = __importStar(require("../../generated/babylon/epoching/v1/tx"));
const createStakeMsg = ({ delegatorAddress, validatorAddress, amount }) => {
    const wrappedDelegateMsg = epochingtx.MsgWrappedDelegate.fromPartial({
        msg: {
            delegatorAddress,
            validatorAddress,
            amount: {
                denom: 'ubbn',
                amount: amount.toString()
            }
        },
    });
    return {
        typeUrl: constants_1.REGISTRY_TYPE_URLS.MsgStakeBABY,
        value: wrappedDelegateMsg,
    };
};
const createUnstakeMsg = ({ delegatorAddress, validatorAddress, amount }) => {
    const wrappedUndelegateMsg = epochingtx.MsgWrappedUndelegate.fromPartial({
        msg: {
            delegatorAddress,
            validatorAddress,
            amount: {
                denom: 'ubbn',
                amount: amount.toString()
            }
        }
    });
    return {
        typeUrl: constants_1.REGISTRY_TYPE_URLS.MsgUnstakeBABY,
        value: wrappedUndelegateMsg,
    };
};
const createClaimRewardMsg = (params) => {
    const withdrawRewardMsg = tx_1.MsgWithdrawDelegatorReward.fromPartial(params);
    return {
        typeUrl: constants_1.REGISTRY_TYPE_URLS.MsgWithdrawRewardForBABYStaking,
        value: withdrawRewardMsg,
    };
};
exports.default = {
    createStakeMsg,
    createUnstakeMsg,
    createClaimRewardMsg,
};
//# sourceMappingURL=baby.js.map